import { animate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { formatNumber } from "@/lib/utils";

interface AnimatedNumberProps {
  to: number;
  className?: string;
  formatter?: (value: number) => string;
}
export function AnimatedNumber(props: AnimatedNumberProps) {
  const nodeRef = useRef<any>(null);
  const [from, setFrom] = useState<number>(0);

  useEffect(() => {
    const node = nodeRef.current;

    const controls = animate(from, props.to, {
      duration: 0.5,
      onUpdate(value: number) {
        if (node) {
          node.textContent = props.formatter
            ? props.formatter(value)
            : formatNumber(value.toFixed(0));
          setFrom(value);
        }
      },
    });

    return () => controls.stop();
  }, [props.to]);

  return <span className={props.className} ref={nodeRef} />;
}
